import { useQuery } from "@tanstack/react-query";
import { apiInstance } from "../utils/_apiInstance";

export interface LegislationOptions {
  nome: string;
  id: string;
  apelidos: string[];
}

export const getLegislationOptions = async () => {
  const response =
    await apiInstance.get<LegislationOptions[]>("legislacao/opcoes");
  console.log(response.data);
  return response.data;
};

export const useLegislationOptionsQuery = () =>
  useQuery({
    queryKey: ["get-legislation-options"],
    queryFn: () => getLegislationOptions(),
    staleTime: Infinity,
    gcTime: Infinity,
    retry: (count) => {
      return count < 2;
    },
  });
